import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../utils/api';

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/blog/${slug}`).then(r => setPost(r.data.post)).catch(() => {}).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="loading-center"><div className="spinner" /></div>;
  if (!post) return <div className="container" style={{ padding: '4rem 0', textAlign: 'center' }}><h2>Post not found</h2><Link to="/blog" className="btn btn-primary" style={{ marginTop: '1rem' }}>Back to Blog</Link></div>;

  return (
    <div>
      <div className="page-hero" style={{ padding: '3rem 0' }}>
        <div className="container">
          <span className="badge badge-green" style={{ marginBottom: '1rem', display: 'inline-block' }}>{post.category}</span>
          <h1 style={{ fontSize: 'clamp(1.75rem, 3vw, 2.5rem)' }}>{post.title}</h1>
          <p style={{ marginTop: '0.75rem' }}>By {post.author} · {post.readTime} read · {new Date(post.publishedAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
        </div>
      </div>
      <div className="container" style={{ maxWidth: 780, padding: '3rem 1.5rem' }}>
        <div className="blog-content" dangerouslySetInnerHTML={{ __html: post.content }} />
        <div className="blog-disclaimer" style={{ marginTop: '3rem', background: '#fef9c3', border: '1px solid #fde047', borderRadius: 'var(--radius)', padding: '1rem 1.25rem', fontSize: '0.875rem', color: '#854d0e' }}>
          ⚠️ This article is for informational and research purposes only. The compounds discussed are not approved for human use and should only be used in qualified laboratory research settings.
        </div>
        <div style={{ marginTop: '2rem' }}>
          <Link to="/blog" className="btn btn-secondary">← Back to Blog</Link>
        </div>
      </div>
    </div>
  );
}
